export const PRICING = {
  standard: {
    '1u': 850,
    '2u': 850,
    'halve_dag': 1150,
    'hele_dag': 1800,
  },
  game: {
    '6u': 3200,
    'module': 45,
  },
  wetteren: {
    cateringPerPax: 25,
    roomPerGroup: 300,
    maxPerGroup: 30,
  },
  insights: {
    profile: 180,
    workbook: 21.25,
    blocks: 8.50,
  },
  talenten: {
    test: 40, // Aangepast van 25 naar 40
  },
  languageSurcharge: 200
};

export const calculatePrice = (data) => {
  let base = 0;
  let location = 0;
  let extras = 0;
  let surcharge = 0;
  let breakdown = [];

  const pax = parseInt(data.pax) || 1;

  // 1. Basisprijs
  if (data.type === 'game') {
    base = PRICING.game[data.duration] || 0;
    breakdown.push({ label: `Game-based workshop (${data.duration}) incl. 2 trainers`, amount: base });
  } else {
    base = PRICING.standard[data.duration] || 0;
    const durationLabel = data.duration === '1u' ? '1 uur (inspiratiesessie)' : data.duration.replace('_', ' ');
    breakdown.push({ label: `Workshop basisprijs (${durationLabel})`, amount: base });
  }

  // 2. Taal Toeslag
  if (data.language && data.language !== 'nl') {
    surcharge = PRICING.languageSurcharge;
    const langLabels = {
      'bilingual': 'Tweetalig (NL/FR)',
      'fr': 'Frans',
      'en': 'Engels'
    };
    breakdown.push({ label: `Meerprijs voertaal (${langLabels[data.language]})`, amount: surcharge });
  }

  // 3. Locatie
  if (data.location === 'wetteren') {
    const catering = pax * PRICING.wetteren.cateringPerPax;
    const groups = Math.ceil(pax / PRICING.wetteren.maxPerGroup);
    const room = groups * PRICING.wetteren.roomPerGroup;
    location = catering + room;
    breakdown.push({ label: `Catering (${pax} pers.)`, amount: catering });
    breakdown.push({ label: `Zaalhuur (${groups} zaal/zalen)`, amount: room });
  }

  // 4. Extras
  if (data.type === 'insights') {
    if (data.insightsProfiles === 'yes') {
      const cost = pax * PRICING.insights.profile;
      extras += cost;
      breakdown.push({ label: `Insights profielen incl. materiaal (${pax} pers.)`, amount: cost });
    } else if (data.insightsProfiles === 'no') {
      if (data.insightsWorkbooks) {
        const cost = pax * PRICING.insights.workbook;
        extras += cost;
        breakdown.push({ label: `Insights werkboeken (${pax} pers.)`, amount: cost });
      }
      if (data.insightsBlocks) {
        const cost = pax * PRICING.insights.blocks;
        extras += cost;
        breakdown.push({ label: `Insights blokjes (${pax} pers.)`, amount: cost });
      }
    }
  } else if (data.type === 'talenten') {
    if (data.talentTest === 'yes') {
      const cost = pax * PRICING.talenten.test;
      extras += cost;
      breakdown.push({ label: `Online talententest (${pax} pers.)`, amount: cost });
    }
  } else if (data.type === 'game') {
    if (data.gameModule === 'yes') {
      const cost = pax * PRICING.game.module;
      extras += cost;
      breakdown.push({ label: `Online module (${pax} pers.)`, amount: cost });
    }
  }

  const total = base + location + extras + surcharge;

  return {
    base,
    location,
    extras,
    surcharge,
    total,
    breakdown
  };
};